import React, { ReactNode, createContext, useEffect, useState } from "react";

import { calculateDelay } from "@utils/menuContext";

type ContextType = {
    getActivationDelay: (element: HTMLElement, activeIndex: number) => number;
};

// context //
const MenuContext = createContext<ContextType>({
    getActivationDelay: () => 0,
});

MenuContext.displayName = "MenuContext";

// provider //
const MOUSE_LOCATIONS_TRACKED = 3;

export interface coordinate {
    x: number;
    y: number;
}

const MenuProvider = ({ children }: { children?: ReactNode }) => {
    const [positions, setPositions] = useState([]);

    const addPosition = (position: coordinate) => {
        // @ts-ignore
        setPositions((positions: any[]) => {
            const newPositions = [...positions, position];
            if (newPositions.length > MOUSE_LOCATIONS_TRACKED) {
                newPositions.shift();
            }
            return newPositions;
        });
    };

    useEffect(() => {
        const eventHandler = (event: MouseEvent) => {
            addPosition({ x: event.pageX, y: event.pageY });
        };

        document.addEventListener("mousemove", eventHandler);

        return () => {
            document.removeEventListener("mousemove", eventHandler);
        };
    }, []);

    const getActivationDelay = (
        menuElement: HTMLElement,
        activeIndex: number,
    ) => {
        return calculateDelay(menuElement, activeIndex, positions);
    };

    return (
        <MenuContext.Provider value={{ getActivationDelay }}>
            {children}
        </MenuContext.Provider>
    );
};

export { MenuProvider, MenuContext };
